import { Divider, IconCopy, Text } from 'braid-design-system';
import type { GraphQLUnionType } from 'graphql';
import { useLocation } from 'react-router';
import { InlineCode } from 'scoobie';

import { SchemaMarkdown } from '../components/SchemaMarkdown.tsx';
import { TypeSnippet } from '../components/TypeSnippet.tsx';

import { BasePage } from '#src/components/BasePage/BasePage.tsx';
import { SchemaSection } from '#src/components/SchemaSection/SchemaSection.tsx';

export const UnionSchemaPage = ({
  unionType,
}: {
  unionType: GraphQLUnionType;
}) => (
  <BasePage
    title={{
      children: <InlineCode weight="weak">{unionType.name}</InlineCode>,
      htmlTitle: unionType.name,
      stringTitle: unionType.name,
      subHeading: (
        <Text icon={<IconCopy />} size="small" weight="medium" tone="secondary">
          Union
        </Text>
      ),
    }}
    breadcrumbs={[
      { href: '/schema', title: 'Schema' },
      { href: useLocation().pathname, title: unionType.name },
    ]}
  >
    <SchemaMarkdown type={unionType.name} />

    <Divider />

    <SchemaSection heading="Member types">
      {Object.entries(unionType.getTypes()).map(([typeName, type]) => (
        <TypeSnippet key={typeName} type={type} />
      ))}
    </SchemaSection>
  </BasePage>
);
